import { HttpClient, HttpContext, HttpParams } from '@angular/common/http';
import { inject } from '@angular/core';
import {
  HTTP_CONTEXT_ENDPOINT,
  StrapiCollectionEntityApiResponseOk,
  StrapiEntityApiResponseOk,
  StrapiGetListParameters,
} from '@core/const';
import { stringify } from 'qs';
import { Observable, map } from 'rxjs';
import { StrapiBaseUrlService } from './base-url.service';

export abstract class StrapiCollectionEntityApiService<TAttributes extends object> {
  protected readonly strapiBaseApiUrl = inject(StrapiBaseUrlService).baseApiUrl;

  private http: HttpClient = inject(HttpClient);

  constructor(private readonly entityName: string) {}

  getOne(id: string): Observable<{ id: number } & TAttributes> {
    return this.http
      .get<StrapiEntityApiResponseOk<TAttributes>>(`${this.strapiBaseApiUrl}/${this.entityName}/${id}`, {
        context: new HttpContext().set(HTTP_CONTEXT_ENDPOINT, `${this.strapiBaseApiUrl}/${this.entityName}/:id`),
      })
      .pipe(map((response) => ({ ...response.data }) as { id: number } & TAttributes));
  }

  getList({
    populate = '*',
    ...parameters
  }: StrapiGetListParameters<TAttributes>): Observable<Array<{ id: number } & TAttributes>> {
    return this.http
      .get<StrapiCollectionEntityApiResponseOk<TAttributes>>(`${this.strapiBaseApiUrl}/${this.entityName}`, {
        params: new HttpParams({
          fromString: stringify({ populate: populate, ...parameters }, { encodeValuesOnly: true }),
        }),
        context: new HttpContext().set(HTTP_CONTEXT_ENDPOINT, `${this.strapiBaseApiUrl}/${this.entityName}`),
      })
      .pipe(map((response) => response.data.map((item) => ({ ...item }) as { id: number } & TAttributes)));
  }

  // TODO: add create, update, delete methods
}
